import { render, staticRenderFns } from "./DrawForm.vue?vue&type=template&id=c0bfddb6&"
import script from "./DrawForm.vue?vue&type=script&lang=js&"
export * from "./DrawForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports